import React from 'react';
import Relay from 'react-relay';
import RelayStore from '../../RelayStore';

import CirclePanel from '../../components/CirclePanel';
import UpdateCircleMutation from '../../mutations/Circle/UpdateCircleMutation';

class EditCircle extends React.Component {

	state = {
		edit: false,
	}

	onUpdateCircle(circle, circleId) {
		const { viewer } = this.props ;

		let mutation = new UpdateCircleMutation({circle, circleId, viewer});

	  	RelayStore.commitUpdate( mutation, {
			onFailure: (error) => {
				console.log('error', error.getError());
				alert('Update Failed');
			},
			onSuccess: (response) => {
				console.log('success', response);
				alert('Update Success');
			}
	  	});

    }
    
    onUpdate = (circle) => {
		const { viewer } = this.props ;

		let mutation = new UpdateCircleMutation({
			circle,
			circleId: this.props.relay.variables.circleId,
			viewer,
		});

  	RelayStore.commitUpdate( mutation, {
			onFailure: (error) => {
				console.log('error', error.getError());
				alert('Update Failed');
			},
			onSuccess: (response) => {
				console.log('success', response);
				alert('Update Success');
			}
  	});

	}


	componentWillMount() {
		this.props.relay.setVariables({
			circleId: this.props.params.id,
			circleFetch: true,
		})
		this.setState({
			edit: this.props.location.state.edit,
		})
	}

    render() {
	    return (
			<div className="panel" style={{marginTop:20}}>
				{this.props.relay.variables.circleId &&
					<CirclePanel
						viewer={this.props.viewer}
						isEditing={this.state.edit}
					    onUpdateCircle={this.onUpdateCircle.bind(this)}
					    onUpdate={this.onUpdate}
						{...this.props.relay.variables}
				  />
				}
			</div>
	    );
  	}
}

EditCircle.propTypes = ({
  viewer: React.PropTypes.object.isRequired,
  relay: React.PropTypes.object.isRequired,
  children: React.PropTypes.node,
});


export default Relay.createContainer(EditCircle, {
	initialVariables: {
		circleId: null,
		circleFetch: false,
	},
  fragments: {
    viewer: (variables) => Relay.QL`
      fragment on Viewer {
				id
        ${UpdateCircleMutation.getFragment('viewer')}
        ${CirclePanel.getFragment('viewer', variables)}
      }
    `,
  }
});



// WEBPACK FOOTER //
// ./src/pages/Circle/EditCircle.js